export const RECEIPTS_TAB_IDS = {
  pending: "receipts-tab-pending",
  matched: "receipts-tab-matched",
  unmatched: "receipts-tab-unmatched",
} as const;

export type ReceiptsTabId =
  (typeof RECEIPTS_TAB_IDS)[keyof typeof RECEIPTS_TAB_IDS];
